import {MetrikaProvider, Notifications, ThemeProviderv2 as ThemeProvider} from '@logistics-frontend/blocks'
import {DrawerOverlay} from '@logistics-frontend/blocks/legacy'
import {BoundCardConfigContext} from '@logistics-frontend/bound-card'
import {I18nProvider} from '@logistics-frontend/core/i18n'
import {RumObservableRoot} from '@logistics-frontend/modules/rum'
import {HelmetProvider} from 'react-helmet-async'
import {BrowserRouter} from 'react-router-dom'

import {Routing} from 'src/pages/desktop'
import {appConfig, i18n} from 'src/shared/config'
import {BlocksVisibilityStatesProvider, UserSettingsProvider} from 'src/shared/contexts'

import * as classes from './App.classes'
import {appProps} from './consts'
import {ErrorBoundary} from './ErrorBoundary'

export function App() {
  return (
    <HelmetProvider>
      <MetrikaProvider gtmLink={appConfig.gtmLink} yandexID={appConfig.metrikaID}>
        <ThemeProvider dir={appConfig.dir} locale={appConfig.lang}>
          <I18nProvider t={i18n}>
            <ErrorBoundary i18n={i18n}>
              <RumObservableRoot>
                <Notifications className={classes.notifications}>
                  <BrowserRouter basename={appConfig.basename}>
                    <DrawerOverlay className={classes.drawer} zIndex={1000}>
                      <UserSettingsProvider value={appProps}>
                        <BlocksVisibilityStatesProvider>
                          <BoundCardConfigContext
                            clientId=""
                            country={appProps.country}
                            currency={appProps.currency}
                            device={appProps.device}
                            lang={appProps.lang}
                            makeUrl={appProps.makeApiUrl}
                            trustDomain={appProps.trustDomain}
                          >
                            <Routing />
                          </BoundCardConfigContext>
                        </BlocksVisibilityStatesProvider>
                      </UserSettingsProvider>
                    </DrawerOverlay>
                  </BrowserRouter>
                </Notifications>
              </RumObservableRoot>
            </ErrorBoundary>
          </I18nProvider>
        </ThemeProvider>
      </MetrikaProvider>
    </HelmetProvider>
  )
}
